<template>
	<div id="app">
		<div class="ct-header-on-scroll">
			<ct-header></ct-header>
		</div>
		<div id="ct-header-fixe">
			<ct-header-fixe></ct-header-fixe>
		</div>
		<div id="ct-header-mobile">
			<ct-header-mobile></ct-header-mobile>
		</div>
		<div id="ct-content">
			<div class="ct-content-taille">
				<router-view/>
			</div>
		</div>

		<div id="ct-footer">
			<ct-footer></ct-footer>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
	}

	window.onscroll = function() {
		var header = document.getElementsByClassName('ct-header-on-scroll')[0];
		if ( window.pageYOffset > 50 ) {
			header.classList.add("ct-header-on-scroll-display");
		} else {
			header.classList.remove("ct-header-on-scroll-display");
		}
	}

</script>

<style>
	@font-face {
		font-family: 'EnterTheGrid';
		src: url('./assets/fonts/Enter-The-Grid.ttf') format('truetype');
	}

	html, body {
		width: 100%;
		height: 100%;
		margin: 0;
		color: #4A4A4A;
	}

	a, a:hover, a:active, a:visited {
		color: #4A4A4A;
		text-decoration-line: none;
		cursor: default;
	}

	h1 {
		font-size: 2.5rem;
	}

	h2 {
		font-size: 2rem;
	}

	h3 {
		font-size: 1.5rem;
	}

	.ct-primary-color {
		color: #B0E900;
	}

	.ct-secondary-color {
		color: #4A4A4A;
	}

	.ct-clean-color {
		color: #FAFAFA;
	}

	.ct-resolution-width {
		width: 70%;
	}

	.ct-policy-enter {
		font-family: 'EnterTheGrid';
	}

	#app {
		font-family: 'Roboto', sans-serif;
		min-height: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	.ct-header-on-scroll {
		flex-shrink: 0;
		position: fixed;
		top: -100px;
		width: 100%;
		z-index: 1000;
		transition: top 1.5s;
	}

	#ct-header-fixe {
		flex-shrink: 0;
	}

	.ct-header-on-scroll-display {
		top: 0px;

	}

	#ct-header-mobile {
		display: none;
	}
	#ct-content {
		display: flex;
		justify-content: center;
		flex-shrink: 0;
		flex-grow: 1;
		/*padding: 5%;*/
	}

	.ct-content-taille {
		display: flex;
		justify-content: space-between;
		/*width: 70%;*/
	}

	#ct-footer {
		flex-shrink: 0;
	}

	.ct-clickable:hover {
		cursor: pointer;
	}

	.ct-justify-text {
		text-align: justify;
		text-justify: auto;
	}

	.ct-puce {
		color: #B0E900;
		font-size: 1.1em;
	}

	.ct-bouton {
		color: #B0E900;
		background-color: #4A4A4A;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.6);
	}

	.ct-bouton:hover {
		color: #CCFF33;
		background-color: #4A4A4A;
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.6);
	}

	/*!*tablette*!*/
	@media screen and (max-width: 1170px ) {
		.ct-resolution-width {
			width: 85%;
		}

		#ct-header-mobile {
			display: block;
			flex-shrink: 0;
			z-index: 100;
		}

	}

	/*!*smartphone*!*/
	@media screen and (max-width: 767px ) {
		.ct-header-on-scroll,
		#ct-header-fixe {
			display: none;
		}
	}



</style>



// WEBPACK FOOTER //
// src/App.vue